"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TemperatureTimePeriod = function TemperatureTimePeriod(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.68,15.78V2.52a2.5,2.5,0,0,0-5,0V15.78a4.5,4.5,0,1,0,5,0ZM9.18,21a1.5,1.5,0,0,1-.5-2.91V7.52a.5.5,0,1,1,1,0V18.11A1.5,1.5,0,0,1,9.18,21Z",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.56.25a3.68,3.68,0,1,0,3.68,3.68A3.68,3.68,0,0,0,17.56.25Zm1.8,5.47a.15.15,0,0,1-.22,0L17.3,4a.15.15,0,0,1,0-.11V2.24a.15.15,0,0,1,.31,0V3.86L19.35,5.5A.15.15,0,0,1,19.36,5.72Z",
    style: {
      fill: '#024965'
    }
  }));
};

var _default = TemperatureTimePeriod;
exports["default"] = _default;